module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gX3Bv"))).then(() => module.bundle.root('8rm4T'));